import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskedLine, Reveal } from "../components/Reveal";
import { MagneticButton } from "../components/MagneticButton";
import { scrollToSection } from "../hooks/useLenis";

export const CTA = () => {
    const reduce = useReducedMotion();
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const headlineScale = useTransform(scrollYProgress, [0, 0.45, 1], [0.88, 1, 1.05]);
    const ringScale = useTransform(scrollYProgress, [0, 1], [0.6, 1.25]);
    const glowOpacity = useTransform(scrollYProgress, [0.05, 0.5, 0.95], [0, 1, 0.35]);

    return (
        <section ref={ref} id="cta" className="relative overflow-hidden py-32 md:py-48" data-testid="cta-section">
            <div className="absolute inset-0 flex items-center justify-center" aria-hidden="true">
                <motion.div style={reduce ? {} : { scale: ringScale }} className="absolute">
                    <div className="animate-spin-slow h-[560px] w-[560px] rounded-full border border-dashed border-[#0066FF]/25" />
                </motion.div>
                <div className="absolute h-[380px] w-[380px] rounded-full border border-[#0A0F1D]/5" />
                <motion.div
                    style={reduce ? {} : { opacity: glowOpacity }}
                    className="absolute h-[700px] w-[700px] rounded-full bg-[#0066FF]/8 blur-[130px]"
                />
            </div>
            <div className="bg-grid-faint absolute inset-0 opacity-50" aria-hidden="true" />

            <motion.div
                style={reduce ? {} : { scale: headlineScale }}
                className="relative mx-auto max-w-5xl px-4 text-center will-change-transform sm:px-6"
            >
                <h2 className="font-display text-[11vw] font-extrabold leading-[1.02] tracking-tight text-[#0A0F1D] sm:text-6xl lg:text-7xl">
                    <MaskedLine play delay={0}>YOU HAVE THE VISION.</MaskedLine>
                    <MaskedLine play delay={0.18}>
                        <span className="text-electric-grad">LET&apos;S PUT IT ONLINE.</span>
                    </MaskedLine>
                </h2>
                <Reveal delay={0.45} className="mt-12 flex flex-col items-center gap-5">
                    <MagneticButton testid="cta-start-website" className="px-10 py-5 text-sm sm:text-base" onClick={() => scrollToSection("contact")}>
                        Start Your Website <ArrowRight className="h-5 w-5" />
                    </MagneticButton>
                </Reveal>
            </motion.div>
        </section>
    );
};
